export default [
  {
    path: '/news',
    name: 'news-index',
    meta: {
      isKeepAlive: true,
      index: 1
    },
    component: () =>
      import(/* webpackChunkName: "news" */ '@/pages/news/views/index.vue')
  },
  {
    path: '/news/:id',
    name: 'news-index',
    props: true,
    meta: {
      isKeepAlive: false,
      index: 2
    },
    component: () =>
      import(/* webpackChunkName: "news-detail" */ '@/pages/news/views/news-detail.vue')
  }
]
